<section class="privacy">
  <h2>Política de privacidad</h2>

  <div class="privacy-content">
    <p>
      En cumplimiento de lo dispuesto en el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016 (RGPD), y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), se informa a los usuarios de este sitio web sobre el tratamiento de sus datos personales.
    </p>

    <h3>Responsable del tratamiento</h3>
    <p>
      <strong>Titular:</strong> Ana Pellón Mendoza<br>
      <strong>Colegiada nº:</strong> CA01238<br>
      <strong>Domicilio:</strong> Calle Rosalia de Castro 19, 1ºB, Santander, Cantabria<br>
      <strong>Email de contacto:</strong>&nbsp;<a href="mailto:anapellonpsicologa@gmail.com">anapellonpsicologa@gmail.com</a><br>
      <strong>Teléfono:</strong>&nbsp;<a href="tel:+34675181684">+34 675 181 684</a>
    </p>

    <h3>Finalidad del tratamiento</h3>
    <p>
      Los datos personales facilitados a través del formulario de contacto o mediante correo electrónico se utilizarán exclusivamente para responder a las consultas, solicitudes o citas realizadas por los usuarios. 
      No se utilizarán con fines comerciales ni se cederán a terceros.
    </p>

    <h3>Legitimación</h3>
    <p>
      La base legal para el tratamiento de los datos es el consentimiento expreso del usuario al enviar el formulario de contacto o al establecer comunicación voluntaria con la responsable.
    </p>

    <h3>Conservación de los datos</h3>
    <p>
      Los datos personales se conservarán únicamente durante el tiempo necesario para atender la consulta o gestionar la cita solicitada. Una vez resuelta la solicitud, los datos se eliminarán salvo que exista una relación profesional posterior o se requiera su conservación por obligaciones legales.
    </p>

    <h3>Destinatarios</h3>
    <p>
      No se comunicarán datos a terceros, salvo obligación legal.
    </p>

    <h3>Derechos de los usuarios</h3>
    <p>
      Cualquier persona tiene derecho a obtener confirmación sobre si se están tratando sus datos personales. 
      Los usuarios podrán ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad de los datos, en los términos previstos en la normativa vigente, dirigiendo una solicitud a la dirección de correo electrónico 
      <a href="mailto:anapellonpsicologa@gmail.com">anapellonpsicologa@gmail.com</a>.
    </p>

    <h3>Medidas de seguridad</h3>
    <p>
      Se han adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, de acuerdo con lo establecido en la normativa aplicable.
    </p>

    <h3>Cambios en la política de privacidad</h3>
    <p>
      La responsable se reserva el derecho de modificar la presente política para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la psicología profesional. En dichos supuestos, se anunciarán los cambios en esta página con antelación razonable a su puesta en práctica.
    </p>
  </div>
</section>
